import React, { useState } from "react";
import { useRooms } from '../../hooks/areas/useRooms'
import { Col } from "reactstrap";


export const IndexRooms = () => {

    const {
        InformedConsent
    } = useRooms();

    const [currentIndex, setCurrentIndex] = useState(0);

    const prevQuestion = () => {
        setCurrentIndex((prev) => (prev === 0 ? InformedConsent.length - 1 : prev - 1));
    };

    const nextQuestion = () => {
        setCurrentIndex((prev) => (prev === InformedConsent.length - 1 ? 0 : prev + 1));
    };

    const q = InformedConsent[currentIndex];




    return (
        <>
            <Col sm="12" className="pt-2" style={{ textAlign: "center" }} >
                <h5 className="f-w-600" style={{ color: "#f97316" }} >Consentimiento informado</h5>
            </Col>
            {InformedConsent.length > 0 && (
                <div className="consent-wrapper shadow-sm"  >
                    <div className="consent-card">
                        <p className="consent-indicator">
                            Pregunta {currentIndex + 1} de {InformedConsent.length}
                        </p>
                        <h3 className="consent-question">
                            {q.question}
                        </h3>
                        {q.listReagents.some(r => r.alternativeQuestionsInformed.length > 0) && (
                            <div className="consent-sublist">
                                {q.listReagents.map(r =>
                                    r.alternativeQuestionsInformed.map(alt => (
                                        <p
                                            key={alt.id_alternative_question}
                                            className="consent-subitem"
                                        >
                                            {alt.alternative_question}
                                        </p>
                                    ))
                                )}
                            </div>
                        )}
                        <button onClick={prevQuestion} className="nav-arrow nav-left">◀</button>
                        <button onClick={nextQuestion} className="nav-arrow nav-right">▶</button>
                    </div>

                </div>
            )}
        </>
    )
}
